import { useQuery, useQueryClient } from 'react-query';
import api from 'services';
import { ID, UsersToAssignWalletTransferResponse } from 'services/requests';
import type { ApiError } from 'services/api.errors';
import { QueryKeys } from 'constants/queryKeys';
import type { AxiosError } from 'axios';

export const useGetUsersToAssignWalletTransfer = (walletTransferExternalId?: ID) => {
  const queryClient = useQueryClient();

  const queryKey = [QueryKeys.usersToAssignWalletTransfer, walletTransferExternalId];

  const queryFn = async () => {
    const { data } = await api.getUsersToAssignWalletTransfer(walletTransferExternalId);
    return data;
  };

  return useQuery<UsersToAssignWalletTransferResponse, AxiosError<ApiError>>(
    queryKey,
    queryFn,
    {
      enabled: Boolean(walletTransferExternalId),
      retry: 1,
      initialData() {
        return queryClient.getQueryData<UsersToAssignWalletTransferResponse>(queryKey);
      },
      refetchOnWindowFocus: false,
    },
  );
};
